import React from 'react';
import numeral from 'numeral';
import { get, isEmpty } from 'lodash';

export const EmotionColors = [
  '#491d8b',
  '#6929c4',
  '#8a3ffc',
  '#a56eff',
  '#be95ff',
  '#d4bbff',
  '#e8daff',
  '#f6f2ff',
  '#d9fbfb',
  '#9ef0f0',
  '#3ddbd9',
  '#08bdba',
  '#009d9a',
  '#007d79',
  '#005d5d',
  '#004144'
];

const getEmotionColor = (val, MAX_VALUE = 1) => {
  const indexer = Math.floor(EmotionColors.length / 2);
  const segmentSize = MAX_VALUE / indexer;

  let colorIndex = Math.floor(val / segmentSize + indexer);
  if (colorIndex < 0) {
    colorIndex = 0;
  }

  if (colorIndex > EmotionColors.length - 1) {
    colorIndex = EmotionColors.length - 1;
  }
  return EmotionColors[colorIndex];
};

export const emotionMapping = {
  shocked: String.fromCodePoint(0x1f635),
  sad: String.fromCodePoint(0x1f62d),
  amused: String.fromCodePoint(0x1f606),
  thrilled: String.fromCodePoint(0x1f929),
  confused: String.fromCodePoint(0x1f643),
  bored: String.fromCodePoint(0x1f611),
  scared: String.fromCodePoint(0x1f631),
  frustrated: String.fromCodePoint(0x1f624),
  touched: String.fromCodePoint(0x1f97a),
  reflective: '🤔',
  tense: '😬',
  understood: '😌'
};

export const formatEmotionData = query => {
  if (query.loading) {
    return query;
  }

  return {
    data: query.data.map(d => ({
      ...d,
      color: getEmotionColor(d.emotionPercent)
    })),
    loading: query.loading
  };
};

export const emotionsAxisElement = ({ data }) => {
  if (!data || !data.length) {
    return null;
  }

  const elements = data
    .sort((a, b) => b.emotionPercent - a.emotionPercent)
    .map(e => (
      <div
        key={`emotion-axis-element-${e.emotionName}`}
        className="tvt-title-engagement__emotion-axis-element"
      >
        <div>{emotionMapping[e.emotionName]}</div>
        <div>{e.emotionName}</div>
      </div>
    ));

  return (
    <div className="tvt-title-engagement__emotion-axis-wrapper">{elements}</div>
  );
};

export const getEmotionVotes = ({ data = [] } = {}) => {
  if (isEmpty(data)) {
    return null;
  }

  const minSampleSize = 50;
  const sampleCount = get(data, [0, 'sampleCount'], 0);
  const totalVotesCount = get(data, [0, 'totalVotesCount'], 0);
  const genres = get(data, [0, 'genres'], '')
    .split('|')
    .filter(f => f.length > 0)
    .map(g => (
      <div
        key={`emotion-index-genre-item-${g}`}
        className="cvmi-title__emotion-index-meta-genre-item"
      >
        {g}
      </div>
    ));

  if (sampleCount < minSampleSize) {
    return null;
  }

  return (
    <div className="cvmi-title__emotion-index-meta">
      <div className="cvmi-title__emotion-index-meta-genres">
        Genres Indexed: {genres}
      </div>
      <div className="cvmi-title__emotion-index-meta-sample">
        {' '}
        {`n= ${numeral(sampleCount).format('0,0')} | Total Votes ${numeral(
          totalVotesCount
        ).format('0,0')}`}
      </div>
    </div>
  );
};
